import 'css-chunksrc/client/pages/utilityPage/projectReportTemplatePage/styles.scss';export default {
  "projectReportTemplatePage": "_projectReportTemplatePage_173ns_1",
  "templateToolbar": "_templateToolbar_173ns_8",
  "templateSelector": "_templateSelector_173ns_15",
  "templateSelectorInput": "_templateSelectorInput_173ns_19",
  "templateSelectorIcon": "_templateSelectorIcon_173ns_35",
  "templateSelectorOpen": "_templateSelectorOpen_173ns_43",
  "templateListRoot": "_templateListRoot_173ns_50",
  "templateList": "_templateList_173ns_50",
  "templateListItem": "_templateListItem_173ns_64",
  "templateListItemSelected": "_templateListItemSelected_173ns_75",
  "templateNameGroup": "_templateNameGroup_173ns_79",
  "templateNameInput": "_templateNameInput_173ns_86",
  "removeTemplateButton": "_removeTemplateButton_173ns_102",
  "addTemplateButton": "_addTemplateButton_173ns_115",
  "title": "_title_173ns_129",
  "form": "_form_173ns_135",
  "buttonBox": "_buttonBox_173ns_139",
  "button": "_button_173ns_139",
  "criteriaSection": "_criteriaSection_173ns_161",
  "criteriaList": "_criteriaList_173ns_165",
  "criteriaItem": "_criteriaItem_173ns_172",
  "criteriaItemDisabled": "_criteriaItemDisabled_173ns_190",
  "criteriaIcon": "_criteriaIcon_173ns_196"
};